import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import { DBImportType, DBImportPreview } from '@/types/import';
import { EndpointResponse } from '@/types/endpoints';
import { utils } from '@/utils';
import type { WriteRequestOptions } from '../requestOptions';

const validate = (importType: string) => {
  if (!importType) {
    throw new Error('`importType` is required');
  }
};

type RequestParams = {
  importType: DBImportType;
  file: File;
  skip_rows: number;
};

type Response = DBImportPreview;

export const createImportPreview = async (
  scope: RequestScope,
  { importType, file, skip_rows }: RequestParams,
  requestOptions: WriteRequestOptions
): Promise<EndpointResponse<Response>> => {
  try {
    validate(importType);

    const formData = new FormData();
    formData.append('file', file);
    const path = skip_rows > 0 ? `import_preview/${importType}?skip_rows=${skip_rows}` : `import_preview/${importType}`;

    const response = await scopedApi(scope).post<EndpointResponse<Response>>(path, formData, {
      ...requestOptions,
      // Let the browser set the multipart boundary. The shared API client's
      // JSON default must not transform FormData into JSON.
      headers: { 'Content-Type': undefined },
    });

    return response.data;
  } catch (e) {
    return utils.error.handleAxiosError(e, { redactRequestData: true });
  }
};
